import { useToast } from '@/hooks/useToast';
import { AppButton } from '@/ui/buttons';
import { Tooltip } from 'primereact/tooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';

type CopyIconButtonProps = {
  clipboardValue: string;
  className?: string;
};

export const CopyIconButton: React.FC<CopyIconButtonProps> = ({
  clipboardValue,
  className,
}) => {
  const toast = useToast();
  const { t } = useTranslation();

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    await navigator.clipboard.writeText(clipboardValue);
    toast?.success('', t('clipboard.copied'));
  };

  return (
    <>
      <AppButton
        icon="pi pi-copy"
        type="text"
        className={className}
        onClick={handleClick}
      />
      <Tooltip
        target=".clipboard-hint"
        content={t('clipboard.click')}
        position="top"
      />
    </>
  );
};
